import { render, staticRenderFns } from "./menu3.vue?vue&type=template&id=13d2ef74&scoped=true"
import script from "./menu3.vue?vue&type=script&lang=js"
export * from "./menu3.vue?vue&type=script&lang=js"
import style0 from "./menu3.vue?vue&type=style&index=0&id=13d2ef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2ef74",
  null
  
)

export default component.exports